import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, FormControl, ValidationErrors } from '@angular/forms';

@Directive({
    selector: '[maxValue]',
    providers: [{ provide: NG_VALIDATORS, useExisting: MaxValueDirective, multi: true }]
})
export class MaxValueDirective implements Validator {
    @Input('max') max: number;

    validate(control: FormControl): ValidationErrors | null {
        const invalid = control.value > this.max;
        return invalid ? { 'highValue': { value: control.value } } : null;
    }
}